module.exports = __webpack_public_path__ + "static/media/teri-hislop.ce82964a.md";